import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { EDIT_SELECTION_PARAM } from 'src/common/constants.ts';
import { parseSelection } from 'shared/projects/parseSelection.ts';

export const SharePage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const selection = parseSelection(searchParams);
    useEffect(() => {
        if (selection) {
            const params = new URLSearchParams(selection.searchQuery);
            if (selection.name) {
                params.set(EDIT_SELECTION_PARAM, selection.name);
            }
            navigate({
                search: params.toString(),
                pathname: selection.pathname,
            }, {
                replace: true,
            });
        } else {
            // eslint-disable-next-line no-console
            console.warn('no selection');
        }
    }, [selection, navigate]);
    return selection === null ? 'Share link is malformed' : 'loading...';
};
